import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateRemindersFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.remindersUpdateFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.remindersFilters]);
    },
  });
};
